import { combineReducers } from "redux";
import { ActionTypes } from "../constants";
import user from './user';
import onboarding from './onboarding';
import dashboard from './dashboard';
import portfolio from './portfolio';
import pricing from './pricing';
import wallet from './wallet';
import browse from './browse';
import cart from './cart';
import goals from './goals';
import bse from "./bse";
// import token from "./token";
import baskets from "./baskets";
import  icicCart from "./iciciCart";
import shoppingGoals from './shoppingGoals';
import setAppConfig from './setAppConfig';
import festivalPortfolio from './festivalPortfolio';
import riskProfiler from "./riskProfiler";
import userState from "./userState";
import transactionState from "./transactionState";
import nsdlPdfAnalyser from "./nsdlPdfAnalyser";
import obTpd from "./obTpd";

const appReducer = combineReducers({
  user,
  onboarding,
  dashboard,
  portfolio,
  pricing,
  wallet,
  browse, 
  cart,
  goals,
  bse,
  icicCart,
  baskets,
  shoppingGoals,
  setAppConfig,
  festivalPortfolio,
  riskProfiler,
  userState,
  transactionState,
  nsdlPdfAnalyser,
  obTpd
})

const rootReducer = (state, action) => {
  if (action.type === ActionTypes.RESET_STORE) {
    state = {};
  }

  return appReducer(state, action)
}

export default rootReducer;
